import { RiArrowLeftSLine, RiArrowRightSLine } from "@remixicon/react";
import { getWeekNumber } from "../utils";

const WeekNavigation = ({ currentWeekStart, onWeekSelect }) => {
  const currentWeekNumber = getWeekNumber(currentWeekStart);
  const previousWeekStart = new Date(currentWeekStart);
  previousWeekStart.setDate(previousWeekStart.getDate() - 7);
  const previousWeekNumber = getWeekNumber(previousWeekStart);

  const nextWeekStart = new Date(currentWeekStart);
  nextWeekStart.setDate(nextWeekStart.getDate() + 7);
  const nextWeekNumber = getWeekNumber(nextWeekStart);

  const handlePreviousWeek = () => {
    onWeekSelect?.(previousWeekStart);
  };

  const handleNextWeek = () => {
    onWeekSelect?.(nextWeekStart);
  };

  return (
    <div className="flex items-center justify-between mt-4">
      <button
        onClick={handlePreviousWeek}
        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-2xl transition-colors"
      >
        <RiArrowLeftSLine className="w-4 h-4" />
        Week {previousWeekNumber}
      </button>

      <span className="px-3 py-1.5 text-sm font-medium text-gray-900">
        Week {currentWeekNumber}
      </span>

      <button
        onClick={handleNextWeek}
        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-2xl transition-colors"
      >
        Week {nextWeekNumber}
        <RiArrowRightSLine className="w-4 h-4" />
      </button>
    </div>
  );
};

export default WeekNavigation;
